import { Box, Button, Grid } from '@material-ui/core';
import { useStyles } from './dashboard-propanga-styles'
import { useCallback } from 'react';
import ConexaoVarejo from '../../../../../../assets/img/conexaoVarejo.png'
import PixSplit from '../../../../../../assets/img/pixSplit.png'
import classNames from 'classnames';

interface DashboardPropagandaRevendaProps {
    whatsapp: string,
    onClick: () => void,
    img: string,
    tipo: 'conexao' | 'pix'
}

const DashboardBanner = (props: DashboardPropagandaRevendaProps
) => {
    const classes = useStyles();

    let texto = 'Olá, gostaria de saber mais sobre'

    if (props.tipo === 'conexao') {
        texto += ' o Conexão Varejo'
    } else {
        texto += ' o Pix Split'
    }

    const urlWhatsapp = `https://api.whatsapp.com/send?phone=55${props.whatsapp}&text=${texto}`;

    const abrirWhatsapp = useCallback(() => {
        window.open(`${urlWhatsapp}`, '_blank');
    }, [urlWhatsapp])

    return (
        <div className={classes.mapContainer}>
            <img src={props.img} alt="imagem conexão varejo" />
            <Box className={classNames(props.tipo === 'pix' && classes.alterarLado, classes.contentButton)}>
                <Button
                    variant='contained'
                    color='secondary'
                    size='large'
                    className={classNames(classes.gerenteButton)}
                    onClick={abrirWhatsapp}
                >Começar a Ganhar</Button>
                <Button
                    variant='outlined'
                    color='secondary'
                    size='large'
                    className={classNames(classes.gerenteButton, classes.saibaMais)}
                    onClick={(e) => {
                        e.preventDefault()
                        props.onClick()
                    }}
                >Saiba Mais</Button>
            </Box>
        </div>
    )
}

export default function DashboardPropagandaRevenda() {

    // const { getPessoaById, carregando } = useGetPessoaById();

    // const { tipoUsuario, usuario } = useSessaoAtual();

    const urlPdfConexao = 'https://drive.google.com/file/d/1gjB18j1ItWBka7o2q9HCa2glluWZo3gV/view?usp=drive_link'

    const urlPdfPix = 'https://drive.google.com/file/d/1O0IMr5xcUdN8NOAjCONbMgK0pGgcT64W/view?usp=drive_link'


    const abrirComecarGanhar = useCallback(async (tipo: 'conexao' | 'pix') => {
        try {
            // const revenda = await getPessoaById(usuario?.Id ?? '');
            // if (revenda.erro) throw revenda.erro
            // const resultadoRevenda = revenda.resultado?.data as PessoaModel
            // const { gerenteId } = resultadoRevenda
            // if (gerenteId) {
            //     const gerente = await getPessoaById(gerenteId)
            //     if (gerente.erro) throw gerente.erro
            //     console.log(gerente.resultado?.data)
            // }

            if (tipo === 'conexao') {
                window.open(`${urlPdfConexao}`, '_blank')
                return
            }
            window.open(`${urlPdfPix}`, '_blank')

        } catch (err: any) {
            console.log(err.message)
        }

    }, [])

    return (
        <Box p={1}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={6}>
                    <DashboardBanner
                        tipo='pix'
                        whatsapp='11954023195'
                        onClick={() => abrirComecarGanhar('pix')}
                        img={PixSplit}
                    />
                    
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6}>
                    <DashboardBanner
                        tipo='conexao'
                        whatsapp='11988953452'
                        onClick={() => abrirComecarGanhar('conexao')}
                        img={ConexaoVarejo}
                    />
                    
                </Grid>
            </Grid>
        </Box>
    );
}
